document.addEventListener('DOMContentLoaded', function () {
  const tipWrapper = document.getElementById('tip-upgrade');
  if (!tipWrapper) return;

  const productForm = document.querySelector('form[action="/cart/add"]');
  if (!productForm) return;

  productForm.addEventListener('submit', async function (e) {
    const selectedTip = tipWrapper.querySelector('input[name="tip_upgrade"]:checked');
    const tipVariantId = selectedTip ? selectedTip.value : '';

    // Nessun cuoio selezionato: comportamento nativo del tema
    if (!tipVariantId) return;

    e.preventDefault();
    e.stopPropagation();

    const mainVariantInput = productForm.querySelector('[name="id"]');
    const mainVariantId = mainVariantInput ? mainVariantInput.value : null;
    if (!mainVariantId) return;

    // Quantità scelta sulla pagina prodotto (fallback 1)
    const qtyInput = productForm.querySelector('[name="quantity"]');
    let qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;

    // Etichette localizzate (window.bhTip viene da tip-upgrade.liquid)
    const S = window.bhTip || {};
    const cueLabel = S.cueLabel || 'Tip';
    const tipLabel = S.tipLabel || 'Fitted on';
    const suffix = S.cueSuffix ? ' ' + S.cueSuffix : '';
    const tipTitle = selectedTip.dataset.title || '';
    const cueTitle = S.cueTitle || '';

    // ID condiviso invisibile al cliente: lega le due righe nel carrello
    const pair = 'bh' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);

    const cueProps = {};
    cueProps[cueLabel] = (tipTitle + suffix).trim();
    cueProps._pair = pair;

    const tipProps = {};
    tipProps[tipLabel] = cueTitle;
    tipProps._pair = pair;

    const btn = productForm.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: mainVariantId, quantity: qty, properties: cueProps },
            { id: tipVariantId, quantity: qty, properties: tipProps }
          ]
        })
      });

      // Shopify risponde 422 senza lanciare eccezione: va controllato a mano
      if (!res.ok) {
        const data = await res.json().catch(function () { return {}; });
        throw new Error(data.description || data.message || 'add failed');
      }

      window.location.href = '/cart';
    } catch (err) {
      console.error('Tip upgrade error:', err);
      if (btn) btn.removeAttribute('aria-busy');
      // Niente fallback al submit nativo: eviterebbe il cuoio e lascerebbe
      // il cliente con la sola stecca senza accorgersene.
      alert(
        document.documentElement.lang.indexOf('it') === 0
          ? 'Non è stato possibile aggiungere il cuoio selezionato. Riprova o scegli un altro cuoio.'
          : 'We could not add the selected tip. Please try again or choose another tip.'
      );
    }
  });
});